module.exports = __webpack_public_path__ + "img/escovacao-supervisionada.3be941af.svg";